const { createSlice } = require('@reduxjs/toolkit');

const productSlice = createSlice({
    name: 'product',
    initialState: {
        products: [],
        categories: [],
        labels: [],
        catalogError: "",
        // True until the first catalog fetch settles. Without it an in-flight
        // request and an empty catalog look identical -- both render
        // "Showing 0 of 0 products" -- and the shop reads as broken for the
        // second or two the ~700 KB fetch takes. `product` is blacklisted from
        // redux-persist, so this starts true on every boot rather than being
        // restored as false from a previous session.
        catalogLoading: true,
    },
    reducers: {
        setProducts(state, action) {
            state.products = action.payload;
            state.catalogError = "";
            state.catalogLoading = false;
        },
        setCategories(state, action) {
            state.categories = action.payload;
        },
        setLabels(state, action) {
            state.labels = action.payload;
        },
        setCatalogError(state, action) {
            state.catalogError = action.payload || "";
            state.products = [];
            state.catalogLoading = false;
        },
        setCatalogLoading(state, action) {
            state.catalogLoading = Boolean(action.payload);
        }
    },
});

export const { setProducts, setCategories, setLabels, setCatalogError, setCatalogLoading } = productSlice.actions;
export default productSlice.reducer;
